import axios from "axios";
import router from "@/router";
import { myMessage } from "./message";
import { getToken, clearToken } from "@/utils/h5Plus";

const baseURL = window.config.url;

export const prefix = "";
const timeout = 60000;
let errotTime = null;
const requestBase = axios.create({
  baseURL,
  timeout,
  headers: {
    "Cache-Control": "no-cache"
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let token = "";
requestBase.interceptors.request.use(
  async config => {
    token = await getToken();
    config.headers["Authorization"] = "Bearer " + token;
    config.headers["Accept"] = "application/json";
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
requestBase.interceptors.response.use(
  response => {
    const { status, statusText } = response;
    if (response.data.status == 200) {
      return Promise.resolve(response.data);
    } else {
      myMessage(response.data.message);
      return Promise.reject(response);
    }
  },
  error => {
    console.log(error, "00");
    if (!errotTime) {
      if (error.response && error.response.status == 500) {
        const { message } = error.response.data;

        errotTime = setTimeout(() => {
          errotTime = null;
        }, 500);
      } else if (error.response && error.response.status == 401) {
        myMessage("登录失效！");
        clearToken();
        router.push({ path: "login", replace: true });
        return;
      } else {
        errotTime = setTimeout(() => {
          errotTime = null;
        }, 500);
      }
      myMessage(error.message);

      return Promise.reject(error);
    }
  }
);

/**
 * @param {AxiosRequestConfig} Config 接口地址
 * @param {string}  prefixValue 接口地址
 * @returns { AxiosPromise | Promise<any>} 返回接口
 */
function request(Config, prefixValue = "") {
  requestBase.defaults.baseURL = Config.baseURL ? Config.baseURL : baseURL;
  Config.url = `${prefixValue}${Config.url}`;
  return requestBase(Config);
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/axios.js